export const SET_SESSION = 'SET_SESSION';
export const SET_SESSION_OFFER = 'SET_SESSION_OFFER';
export const SET_OFFER_ID = 'SET_OFFER_ID';
export const SET_OFFER_INVALID = 'SET_OFFER_INVALID';
export const SET_USER_SESSION = 'SET_USER_SESSION';
export const SET_MODALITY = 'SET_MODALITY';
export const SAVE_PURCHASE = 'SAVE_PURCHASE';
export const SAVE_PAYMENT_DATA = 'SAVE_PAYMENT_DATA';
export const CLEAN_PAYMENT_DATA = 'CLEAN_PAYMENT_DATA';
export const SET_PRICE = 'SET_PRICE';
export const SET_IS_NOSSA = 'SET_IS_NOSSA';
export const SET_IS_INSIDE_APP = 'SET_IS_INSIDE_APP';
export const SET_OLD_OFFER_PRICE = 'SET_OLD_OFFER_PRICE';
export const SET_OLD_OFFER_ID = 'SET_OLD_OFFER_ID';
export const SET_IS_PRICE_FROM_HIDDEN = 'SET_IS_PRICE_FROM_HIDDEN';
export const SET_IS_ANNUAL_PRICE_HIDDEN = 'SET_IS_ANNUAL_PRICE_HIDDEN';

export function setSession(uuid) {
  return {
    type: SET_SESSION,
    uuid,
  };
}

export function setSessionOffer(offer) {
  return {
    type: SET_SESSION_OFFER,
    offer,
  };
}

export function setOfferId(offerId) {
  return {
    type: SET_OFFER_ID,
    offerId,
  };
}

export function setInvalidOffer(offerCondition) {
  return {
    type: SET_OFFER_INVALID,
    offerCondition,
  };
}

export function setUserSession(userToken) {
  return {
    type: SET_USER_SESSION,
    userToken,
  };
}
export function setModality(modality) {
  return {
    type: SET_MODALITY,
    modality,
  };
}

export function savePurchase(purchase) {
  return {
    type: SAVE_PURCHASE,
    purchase,
  };
}

export function savePaymentData(paymentData) {
  return {
    type: SAVE_PAYMENT_DATA,
    paymentData
  };
}

export function cleanPaymentData() {
  return {
    type: CLEAN_PAYMENT_DATA,
    paymentData: {}
  };
}

export function setPrice(offerPrice) {
  return {
    type: SET_PRICE,
    offerPrice,
  };
}

export function setIsNossa(isNossa) {
  return {
    type: SET_IS_NOSSA,
    isNossa,
  };
}

export function setIsInsideApp(isInsideApp) {
  return {
    type: SET_IS_INSIDE_APP,
    isInsideApp,
  };
}

export function setOldOfferId(offerId) {
  return {
    type: SET_OLD_OFFER_ID,
    offerId,
  };
}

export function setOldOfferPrice(price) {
  return {
    type: SET_OLD_OFFER_PRICE,
    price,
  };
}

export function setHidePriceFrom(isPriceFromHidden) {
  return {
    type: SET_IS_PRICE_FROM_HIDDEN,
    isPriceFromHidden,
  };
}

export function setHideAnnualPrice(isAnnualPriceHidden) {
  return {
    type: SET_IS_ANNUAL_PRICE_HIDDEN,
    isAnnualPriceHidden,
  };
}
